export default {
  lang: {
    reset: 'Redefinir',
    search: 'Filtragem',
    expand: 'Expansão',
    collapse: 'Recolher',
  },
};
